<template>
  <div class="page-content">
    <div class="card">
      <div class="card-header">
        <h1 class="payment-success-title">{{ title }}</h1>
      </div>
      <CustomIcon
        name="illustrations/holding-phone-half-circle"
        class="payment-image || small"
      />
      <CustomIcon name="logo" class="payment-success-img" />
      <div class="badge-set">
        <DownloadBadge image="apple-badge" :hyperlink="links.apple" />
        <DownloadBadge image="google-play-badge" :hyperlink="links.google" />
      </div>
      <p class="payment-success-text">Use your email to log in</p>
      <p class="payment-success-text">{{ formData.email.value }}</p>
    </div>
  </div>
</template>
<script>
import DownloadBadge from "@/components/DownloadBadge";
import CustomIcon from "@/components/CustomIcon.vue";
import { EXTERNAL_ROUTES } from "@/config";

export default {
  data() {
    return {
      links: {
        apple: EXTERNAL_ROUTES.appleAppDownload,
        google: EXTERNAL_ROUTES.googlePlayAppDownload,
      },
    };
  },
  props: {
    title: String,
    formData: Object,
  },
  components: { DownloadBadge, CustomIcon },
};
</script>
